export default {
  mainContainer: 'search-header__results-count fds-u-pt2',
  seoHeading:
    'fds-c-text-heading -color-light -size-xs h-remove-margin -weight-normal',
  seoSubHeading:
    'fds-c-text-heading -color-light -size-xs -weight-normal fds-u-hide-small-and-below',
  seoFinePrint:
    'search-header__fine-print fds-c-text-heading -color-light -weight-normal',
  suggestionsContainer: 'search-header__extras',
  authorText: 'author-search-result'
}



// WEBPACK FOOTER //
// ./client/components/searchHeader/themes/resultHeadersDefault.ts